/** 共通で使用する型はここに書く */
/** enum likeのバリューでユニオン型を定義する時に使用するもの */
export type valueof<T> = T[keyof T];

/** 一覧取得API検索結果数モード */
export const SearchResultsCountMode = {
  need: 'need',
} as const;

/** 更新モード */
export const UpdateMode = {
  all: 'all',
  part: 'part',
} as const;

/** 更新クエリパラメータ */
export interface UpdateModeQueryDto {
  'update-mode': valueof<keyof typeof UpdateMode>;
}

/** エラーコード */
export const ERROR_CODE = {
  PLAN_LIMIT_EXCEPTION: 493,
  COMMON_EXCEPTION: 599,
} as const;

/** アップロードファイルのfieldName */
export const UploadFileFieldName = {
  accountIcon: 'image',
  accountHeader: 'image',
  skillsheet: 'skillsheet',
  attachmentFiles: 'attachmentFiles',
} as const;

/** 表示言語 */
export const LanguageCode = {
  ja: 'ja',
  en: 'en',
} as const;

/** 通知、アクティビティメッセージ作成用のカテゴリー */
export const MessageCategoryCd = {
  currentResponsiblePerson: 'currentResponsiblePerson',
  notCurrentResponsiblePerson: 'notCurrentResponsiblePerson',
  practitioner: 'practitioner',
  notPractitioner: 'notPractitioner',
  member: 'member',
} as const;
